<template>
  <v-content v-if="profileStore !== false">
    <v-container>
      <v-alert :value="displayAlert" :color="alertType">{{alertMsg}}</v-alert>
      <h1 class="subheading grey--text">My Account</h1>
      <v-card>
        <v-container>
          <div>
            <p>Email: {{email}}</p>
            <p>Balance: {{earningsAmount}} points</p>
          </div>
          <div>
            <v-btn
              @click="$router.push('cash-out')"
              color="green"
              class="btn-margin-10 white--text"
            >
              <v-icon let>attach_money</v-icon>
              <span>Cash Out</span>
            </v-btn>
          </div>
          <v-btn @click="$router.push('email-change')" color="gray" class="btn-margin-10">
            <v-icon left>email</v-icon>
            <span>Change Email</span>
          </v-btn>

          <div>
            <v-btn @click="$router.push('password-change')" color="gray" class="btn-margin-10">
              <v-icon left>security</v-icon>
              <span>Change password</span>
            </v-btn>
          </div>
        </v-container>
      </v-card>
    </v-container>
  </v-content>
</template>
<script>
import firebase from "firebase";
import { mapGetters } from "vuex";
export default {
  name: "Profile",
  data: () => ({
    alertMsg: "",
    alertType: "",
    displayAlert: false,
    password: "",
    show: false,
    earningsAmount: null
  }),
  computed: {
    ...mapGetters(["profileStore"])
  },
  created: function() {
    let msgData = this.$route.query;
    //console.log("HERE IS THE CONFIRM DATA: ", confirmData);
    this.auth = firebase.auth().currentUser.uid;
    this.email = firebase.auth().currentUser.email;
    this.alertMsg = msgData.msg;
    this.alertType = msgData.msg_type;
    if (msgData.msg_show === true) {
      this.displayAlert = true;
    }
  },
  methods: {
    loadEarnings() {
      try {
         this.earningsAmount = this.$store.state.profile.profileInfo.earnings.balance;
      } catch (e) {
        return 
      }
    }
  },
  mounted() {
    this.loadEarnings();
  }
};
</script>

<style scoped>
.btn-margin-10 {
  margin: 10px;
}
</style>